// src/components/LoadingScreen.jsx
import React from "react";
import EvoWishesLogo from "../assets/evo_wishes.png"; // Replace with your actual logo

export default function LoadingScreen({ backgroundImage }) {
  // Number of hearts and balloons you want floating around
  const HEART_COUNT = 52;
  const BALLOON_COUNT = 34;

  // Generate random left positions and animations for hearts
  const heartsData = Array.from({ length: HEART_COUNT }, () => ({
    left: Math.random() * 100, // random percentage from 0% to 100%
    delay: Math.random() * 3, // random delay in seconds
    size: Math.floor(Math.random() * 20) + 20, // random size (20px - 40px)
  }));

  // Generate random left positions and animations for balloons
  const balloonsData = Array.from({ length: BALLOON_COUNT }, () => ({
    left: Math.random() * 100,
    delay: Math.random() * 3,
    size: Math.floor(Math.random() * 30) + 30, // balloons can be a bit bigger
    color: getRandomColor(), // optional: random color
  }));

  return (
    <div className="relative w-screen h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Background Image */}
      {backgroundImage && (
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        ></div>
      )}

      {/* Crystal/Glassy Overlay */}
      <div className="absolute inset-0 bg-white bg-opacity-30 backdrop-filter backdrop-blur-md" />

      {/* Center Logo + Loading Text */}
      <div className="flex flex-col items-center z-10">
        <img
          src={EvoWishesLogo}
          alt="EvoWishes Logo"
          className="h-20 w-auto mb-4 animate-pulse"
        />
       
      </div>

      {/* Floating Hearts */}
      {heartsData.map((heart, idx) => (
        <div
          key={`heart-${idx}`}
         
          className="absolute bottom-0"
          style={{
            top: "100%",
            left: `${heart.left}%`,
            animationDelay: `${heart.delay}s`,
            animationName: "floatUp",
            animationDuration: "2s",
            animationTimingFunction: "linear",
            animationIterationCount: "infinite",
          }}
        >
          <svg
            width={heart.size}
            height={heart.size}
            viewBox="0 0 24 24"
            fill="currentColor"
            className="text-red-500"
          >
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 
              12.28 2 8.5 2 
              5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 
              2.09C13.09 3.81 14.76 3 16.5 
              3 19.58 3 22 5.42 22 8.5c0 
              3.78-3.4 6.86-8.55 
              11.54L12 21.35z"
            />
          </svg>
        </div>
      ))}

      {/* Floating Balloons */}
      {balloonsData.map((balloon, idx) => (
        <div
          key={`balloon-${idx}`}
          className="absolute bottom-0"
          style={{
            top: "100%",
            left: `${balloon.left}%`,
            animationDelay: `${balloon.delay}s`,
            animationName: "floatUp",
            animationDuration: "2.5s",
            animationTimingFunction: "linear",
            animationIterationCount: "infinite",
          }}
        >
          {/* Example balloon (simple SVG oval + tail). Adjust as desired. */}
          <svg
            width={balloon.size}
            height={balloon.size + 10} // extra space for a tail
            viewBox="0 0 24 34"
            className="overflow-visible"
          >
            {/* Balloon Body (ellipse) */}
            <ellipse
              cx="12"
              cy="12"
              rx="10"
              ry="12"
              fill={balloon.color}
            />
            {/* Balloon Tail (line or small path) */}
            <path
              d="M12,24 C12,26 10,28 12,34"
              stroke={balloon.color}
              strokeWidth="2"
              fill="none"
            />
          </svg>
        </div>
      ))}

      {/* Inline keyframes for hearts & balloons floating up */}
      <style jsx>{`
        @keyframes floatUp {
          0% {
            transform: translateY(0);
            opacity: 1;
          }
          80% {
            opacity: 1;
          }
          100% {
            transform: translateY(-120vh);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
}

/** Optional helper to get random bright colors for balloons */
function getRandomColor() {
  const colors = [
    "#FEC5E5", // pink
    "#FF88DC", // magenta
  ];
  return colors[Math.floor(Math.random() * colors.length)];
}